import { Alert, Spinner } from "react-bootstrap";
import { FaCalendarCheck, FaCheckCircle, FaClock, FaMoneyBillWave, FaTimesCircle } from "react-icons/fa";
import { GiReceiveMoney, GiTakeMyMoney } from "react-icons/gi";
import { useDashboardStats, useBookingTrends, useDriverBookingPerformance, useVehicleBookingCounts, useVehicleCategoryDistribution, useTodayRevenueExpense } from "../../../../api/fleet-management/dashboard/dashboard.hooks";
import BookingTrendsChart from "./_components/BookingTrendsChart";
import DriverBookingPerformanceChart from "./_components/DriverBookingPerformanceChart";
import TodayRevenueExpenseChart from "./_components/TodayRevenueExpenseChart";
import VehicleBookingCountsChart from "./_components/VehicleBookingCountsChart";
import VehicleCategoryDistributionChart from "./_components/VehicleCategoryDistributionChart";
import VehicleAvailabilityCalendar from "./_components/VehicleAvailabilityCalendar";
import StatsRow from "./_components/StatsRow";

const Dashboard = () => {
  const { data: stats, isLoading, isError, error } = useDashboardStats();

  const { data: bookingTrends } = useBookingTrends();

  const { data: driverBookingPerformance } = useDriverBookingPerformance();

  const { data: vehicleBookingCounts } = useVehicleBookingCounts();

  const { data: vehicleCategoryDistribution } = useVehicleCategoryDistribution();

  const { data: todayRevenueExpense } = useTodayRevenueExpense();
  const bookingStats = [
    {
      key: "confirmedBookings",
      label: "Confirmed Bookings",
      value: stats?.confirmedBookings,
      tone: "info",
      icon: FaCalendarCheck,
    },
    {
      key: "completedBookings",
      label: "Completed Bookings",
      value: stats?.completedBookings,
      tone: "success",
      icon: FaCheckCircle,
    },
    {
      key: "cancelledBookings",
      label: "Cancelled Bookings",
      value: stats?.cancelledBookings,
      tone: "danger",
      icon: FaTimesCircle,
    },
    {
      key: "pendingBookings",
      label: "Pending Bookings",
      value: stats?.pendingBookings,
      tone: "warning",
      icon: FaClock,
    },
  ];

  const moneyStats = [
    {
      key: "totalBookings",
      label: "Total Bookings",
      value: stats?.totalBookings,
      tone: "primary",
      icon: FaCalendarCheck,
    },
    {
      key: "totalEarning",
      label: "Total Earning",
      value: stats?.totalEarning,
      tone: "success",
      icon: FaMoneyBillWave,
    },
    {
      key: "refundedAmount",
      label: "Refunded Amount",
      value: stats?.refundedAmount,
      tone: "danger",
      icon: GiReceiveMoney,
    },
    {
      key: "totalExpenses",
      label: "Total Expenses",
      value: stats?.totalExpenses,
      tone: "warning",
      icon: GiTakeMyMoney,
    },
  ];

  if (isLoading) {
    return (
      <div className="container-fluid">
        <div className="card">
          <div className="card-body">
            <div className="d-flex justify-content-center py-5">
              <Spinner animation="border" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="container-fluid">
        <div className="card">
          <div className="card-body">
            <Alert variant="danger" className="mb-0">
              Failed to load dashboard stats.{" "}
              {error?.response?.data?.message || "Please try again."}
            </Alert>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid">
      <StatsRow title="Booking Overview" stats={bookingStats} />
      <StatsRow
        title="Money & Expense Overview"
        stats={moneyStats}
        isCurrency
      />
            <div className="mt-3">
        <VehicleAvailabilityCalendar />
      </div>
      <BookingTrendsChart data={bookingTrends} />
      <TodayRevenueExpenseChart data={todayRevenueExpense} />
      <DriverBookingPerformanceChart data={driverBookingPerformance} />
      <VehicleBookingCountsChart data={vehicleBookingCounts} />
      <VehicleCategoryDistributionChart data={vehicleCategoryDistribution} />
    </div>
  );
};

export default Dashboard;
